import { BrowserRouter, Routes, Route } from "react-router-dom";

import Dashboard from "./pages/Dashboard";
import Checklist from "./pages/Checklist";
import Users from "./pages/Users";
import Leave from "./pages/Leave";
import Attendance from "./pages/Attendance";
import Parking from "./pages/Parking";
import Recruit from "./pages/Recruit";
import RecruitDetails from "./pages/RecruitDetails";
import InterviewSchedule from "./pages/InterviewSchedule";
import Hiring from "./pages/HiringStatus";
import Messages from "./pages/Messages";
import Help from "./pages/Help";
import Settings from "./pages/Settings";

import Profile from "./pages/Profile";
import Notifications from "./pages/Notifications";
import Calendar from "./pages/Calendar";
import EmployeeProfile from "./pages/EmployeeProfile";

import DashboardLayout from "./layout/DashboardLayout";

export default function App() {
  return (
    <BrowserRouter>
      <DashboardLayout>
        <Routes>
          {/* Main Sidebar Routes */}
          <Route path="/" element={<Dashboard />} />
          <Route path="/checklist" element={<Checklist />} />
          <Route path="/users" element={<Users />} />
          <Route path="/leave" element={<Leave />} />
          <Route path="/attendance" element={<Attendance />} />
          <Route path="/parking" element={<Parking />} />
          <Route path="/recruit" element={<Recruit />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/help" element={<Help />} />
          <Route path="/settings" element={<Settings />} />

          {/* Recruit Sub Pages */}
          <Route path="/recruit/details/:id" element={<RecruitDetails />} />
          <Route path="/recruit/interviews" element={<InterviewSchedule />} />
          <Route path="/recruit/hiring" element={<Hiring />} />

          {/* Navbar Pages */}
          <Route path="/profile" element={<Profile />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/calendar" element={<Calendar />} />

          {/* Employee Profile Page */}
          <Route path="/employee-profile" element={<EmployeeProfile />} />
        </Routes>
      </DashboardLayout>
    </BrowserRouter>
  );
}
